'use strict';

(function($) {
    $(function() {

        $('.js-play-galeria-video').click(function(){
            var ytId = $(this).data('yt-id');
            $('.video-player .video-wrapper').html('<iframe width="560" height="315" src="https://www.youtube.com/embed/' + ytId + '?rel=0&amp;enablejsapi=1;controls=0&amp;showinfo=0;autoplay=1;origin=' + document.location.origin + '" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
            $('.video-player').addClass('is-opened');
        });

        $(document).keyup(function(e) {
             if (e.keyCode === 27) {
                 $('.video-player').removeClass('is-opened');
                 $('.video-player .video-wrapper').html('');
            }
        });

        $('.video-player .close').click(function(e) {
             $('.video-player').removeClass('is-opened');
             $('.video-player .video-wrapper').html('');
        });

        $('.js-video-change').click(function(){
            var ytId = $(this).data('yt-id');
            var imageSrc = $(this).data('image-src');
            var infoId = $(this).data('info-id');

            $('.js-video-change.active').removeClass('active');
            $(this).addClass('active');

            $('.video-block').addClass('video-block--hidden');
            $(this).parents('section').find('.js-play-galeria-video').data('yt-id',ytId);

            setTimeout(function(){
                $('.video-block--main').css('background-image','url(' + imageSrc + ')');
                $('.info').hide();
                $('.info-' + infoId).show();
            },500);
            setTimeout(function(){
                $('.video-block').removeClass('video-block--hidden');
            },750);

        });

    });
})(jQuery);
